import { GetterTree } from "vuex";
import { Groupe } from "../../shared/Groupe";
import { Site } from "../../shared/Site";
import { Enseigne } from "../../shared/Enseigne";
import { Siret } from "../../shared/Siret";
import { RootState } from "../types";
import setAxiosHeaders from "./helpers";
import { LoginState } from "./types";

export const getters: GetterTree<LoginState, RootState> = {
  isAuthenticated(state): boolean {
    return !!state.user;
  },
  token(state): string {
    if (state.token) {
      return state.token;
    } else {
      return localStorage.token;
    }
  },
  user(state): any {
    if (state.user) {
      return state.user;
    } else if (localStorage.user) {
      const myUser = JSON.parse(localStorage.user);
      // console.log(myUser);
      setAxiosHeaders(myUser.token);
      state.user = myUser;
      return myUser;
    }
  },
  sites(state): Site[] {
    // console.log("get sites", state.sites);
    if (state.sites && state.sites.length > 0) {
      return state.sites; // .filter((site: Site) => site.libelle !== "NON REMPLI");
      // return state.sites;
    } else if (localStorage.sites) {
      const messites = JSON.parse(localStorage.sites);
      state.sites = messites;
      // console.log(state.sites);
      return messites.filter((site: Site) => site.libelle !== "NON REMPLI");
    }
    return [];
  },
  enseignes(state): Enseigne[] {
    // console.log("get enseignes", state.enseignes);
    if (state.enseignes && state.enseignes.length > 0) {
      return state.enseignes; // .filter((site: Site) => site.libelle !== "NON REMPLI");
      // return state.enseignes;
    } else if (localStorage.enseignes) {
      const mesenseignes = JSON.parse(localStorage.enseignes);
      state.enseignes = mesenseignes;
      // console.log(state.enseignes);
      return mesenseignes;
    }
    return [];
  },
  sirets(state): Siret[] {
    if (state.sirets && state.sirets.length > 0) {
      return state.sirets; // .filter((site: Site) => site.libelle !== "NON REMPLI");
      // return state.sirets;
    } else if (localStorage.sirets) {
      const mesSirets = JSON.parse(localStorage.sirets);
      state.sirets = mesSirets;
      // console.log(state.sirets);
      return mesSirets;
    }
    return [];
  },
  groupements(state): Groupe[] {
    if (state.groupements && state.groupements.length > 0) {
      return state.groupements;
    } else if (localStorage.groupements) {
      const messites = JSON.parse(localStorage.groupements);
      state.groupements = messites;
      return messites;
    }
    return [];
  },
  loading(state): boolean {
    return state.loading;
  },
  language(state): string {
    if (state.language) {
      return state.language;
    } else if (localStorage.language) {
      return localStorage.language;
    }
    return "fr";
  },
};
